import { ComponentProps } from "react";

import { getHeaderTitle } from "@react-navigation/elements";
import { NativeStackHeaderProps } from "@react-navigation/native-stack";

import { Header } from "../../../components";

type Props = NativeStackHeaderProps & ComponentProps<typeof Header>;
export default function DeliveryFulfillmentsHeader(props: Props) {
  const title = getHeaderTitle(props.options, props.route.name);

  return (
    <Header title={title} onBackPress={props.navigation.goBack} {...props} />
  );
}
